var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2Favourite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 62v4H13v-4h49zM14.4 28.38A2 2 0 0115.84 25H29l6.58-13.81a2 2 0 013.66 0L45.39 25H59a2 2 0 011.44 3.38L50.36 38.85l2.38 13.85a2 2 0 01-2.9 2.11l-12.41-6.52L25 54.82a1.911 1.911 0 01-.93.23 2 2 0 01-1.97-2.38l2.4-13.81-10.1-10.48zm6.15.62l7.53 7.81a2 2 0 01.53 1.73l-1.86 10.85 9.75-5.13a2 2 0 011.86 0l9.75 5.12-1.86-10.85a2 2 0 01.53-1.73l7.51-7.8h-10.2a2 2 0 01-1.83-1.19l-4.85-10.89-4.83 10.89A2 2 0 0130.75 29h-10.2z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Favourite.3a37be75.svg";
export { SvgJ2Favourite as ReactComponent };